import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter,
  get_playerIdAdapter2h87xjwribaa as get_playerIdAdapter,
} from '../../../adapter/Adapter.mjs';
import {
  get_StringAdapter1plpsgiy8rwhj as get_StringAdapter,
  get_NullableStringAdapter3fffxc67fmluc as get_NullableStringAdapter,
  presentmhd0a0ip21um as present,
  list2lpjhmv1d2k19 as list,
} from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Badge_ResponseAdapter_instance9mu49fvvgdlz as Badge_ResponseAdapter_instance } from './Badge_ResponseAdapter.mjs';
import { Present1shu3953j96zb as Present } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SavePlayerInput3s7vno6nbe1ix as SavePlayerInput } from '../SavePlayerInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SavePlayerInput_InputAdapterClass;
function SavePlayerInput_InputAdapter() {
  if (SavePlayerInput_InputAdapterClass === VOID) {
    class $ {
      s41(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      k75(writer, customScalarAdapters, value) {
        writer.k4e('partyId');
        get_partyIdAdapter().t41(writer, customScalarAdapters, value.y73_1);
        writer.k4e('playerId');
        get_playerIdAdapter().t41(writer, customScalarAdapters, value.z73_1);
        writer.k4e('name');
        get_StringAdapter().t41(writer, customScalarAdapters, value.a74_1);
        writer.k4e('email');
        get_StringAdapter().t41(writer, customScalarAdapters, value.b74_1);
        writer.k4e('badge');
        Badge_ResponseAdapter_instance.o6x(writer, customScalarAdapters, value.c74_1);
        writer.k4e('callSignAdjective');
        get_StringAdapter().t41(writer, customScalarAdapters, value.d74_1);
        writer.k4e('callSignNoun');
        get_StringAdapter().t41(writer, customScalarAdapters, value.e74_1);
        var tmp = value.f74_1;
        if (tmp instanceof Present()) {
          writer.k4e('imageURL');
          present(get_NullableStringAdapter()).r42(writer, customScalarAdapters, value.f74_1);
        }
        var tmp_0 = value.g74_1;
        if (tmp_0 instanceof Present()) {
          writer.k4e('avatarType');
          present(get_NullableStringAdapter()).r42(writer, customScalarAdapters, value.g74_1);
        }
        writer.k4e('unvalidatedEmails');
        list(get_StringAdapter()).p42(writer, customScalarAdapters, value.h74_1);
      }
      t41(writer, customScalarAdapters, value) {
        return this.k75(writer, customScalarAdapters, value instanceof SavePlayerInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SavePlayerInput_InputAdapter', VOID, VOID, [Adapter()]);
    SavePlayerInput_InputAdapterClass = $;
  }
  return SavePlayerInput_InputAdapterClass;
}
var SavePlayerInput_InputAdapter_instance;
function SavePlayerInput_InputAdapter_getInstance() {
  return SavePlayerInput_InputAdapter_instance;
}
//region block: init
SavePlayerInput_InputAdapter_instance = new (SavePlayerInput_InputAdapter())();
//endregion
//region block: exports
export {
  SavePlayerInput_InputAdapter_instance as SavePlayerInput_InputAdapter_instance3cegmft9cv7tf,
};
//endregion

//# sourceMappingURL=SavePlayerInput_InputAdapter.mjs.map
